/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Component, OnInit, OnChanges, Input, Output, EventEmitter, Type } from '@angular/core';

@Component({
  selector: 'wizard-steps',
  templateUrl: './wizard-steps.component.html',
  styleUrls: ['./wizard-steps.component.scss']
})
export class WizardStepsComponent implements OnInit {

  @Input()
  selectedStep: WizardStep;

  @Input()
  steps: Array<WizardStep>;

  @Output('onChange')
  onChange: EventEmitter<WizardStep> = new EventEmitter<WizardStep>();

  constructor() { }

  ngOnInit() {
  }

  labelOffset(step: WizardStep) {
    return `-${this.calcOffset(step.label)}px`;
  }

  activateStep(step: WizardStep) {
    this.onChange.emit(step);
  }

  private calcOffset(label: string) {
    let offset: number = 0;
    for (let c = 0; c < label.length; c++) {
      if (label[c] == 'i') {
        offset += 1.2;
      }
      else {
        offset += 3.5;
      }
    }
    return offset
  }
}

export interface WizardStep {
  stepNumber: number;
  label: string;
  component?:any;
  options?: any
}



// WEBPACK FOOTER //
// ./client/app/global/wizard-steps/wizard-steps.component.ts